import { TS_Special }           from '../TravelSeller/Models/TS_Special';
import { BookingItemInterface } from './BookingItemInterface';

export class Special extends TS_Special implements BookingItemInterface {}